import client from '../client';
import * as clientRateMutations from "../mutations/clientRate";
import * as clientRateQueries from "../queries/clientRate";

export function getRates(success, error, clientId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        variables: { clientId: clientId },
        query: clientRateQueries.all,
    })
        .then(success)
        .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { clientRate: data },
        mutation: clientRateMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, clientRate: data },
        mutation: clientRateMutations.edit,
    }).then(success).catch(error);
}


export function remove(success, error, id) {
    client.mutate({
        variables: { id: id },
        mutation: clientRateMutations.remove,
    }).then(success).catch(error);
}




// WEBPACK FOOTER //
// ./src/graphql/actions/clientRate.js